const translatePasswordDistro = {
  message: 'Message...',
  sender: 'From',
  receiver: 'Mobile No.',
  passwordDistor: 'PASSWORD DISTRIBUTION',
};

export default translatePasswordDistro;
